class generalFunctions {


    async getDocInfoByFolio(folio) {
        const normalizedFolio = String(folio ?? '')?.trim();

        const codeBO = normalizedFolio?.substring(0, 3);
        const codeFolio = normalizedFolio?.substring(3, 5);
        const DocEntry = normalizedFolio?.substring(5, 50);
        let table = '', subTable = '', msj = '', num = 0, folioID = '';

        const electronicMatch = normalizedFolio?.match(/^([A-Za-z0-9]{2})-[A-Za-z0-9]{4}-.+$/);
        const isElectronic = !!electronicMatch;
        const electronicType = electronicMatch?.[1] ?? '';
        if (isElectronic) {
            switch (electronicType) {
                case '03':
                case '01':
                    table = 'OINV';
                    subTable = 'INV1';
                    msj = "FACTURA DE DEUDORES";
                    num = 13
                    folioID = 'IV';
                    break;
                default:
                    msj = "NO SE ENCONTRÓ EL TIPO DE DOC";
                    folioID = 'NO';
            }
            return { msj, table, subTable, DocEntry, num, folioID, codeBO, isElectronic };
        }

        switch (codeFolio) {
            case 'IH':
                table = '';
                subTable = '';
                msj = "FACTURA A DOMICILIO";
                num = 0;
                folioID = 'IH';
                break;
            case 'IV':
                table = 'OINV';
                subTable = 'INV1';
                msj = "FACTURA DE DEUDORES";
                num = 13
                folioID = 'IV';
                break;
            case 'IN':
                table = '';
                subTable = '';
                msj = "NOTA DE VENTA";
                num = 0
                folioID = 'IN';
                break;

            case 'IR':
                table = '';
                subTable = '';
                msj = "FACTURA DE RESERVA";
                num = 0
                folioID = 'IR';
                break;
            case 'ID':
                table = '';
                subTable = '';
                msj = "FACTURA DE ANTICIPO";
                num = 0
                folioID = 'ID';
                break;
            case 'QT':
                table = 'OQUT';
                subTable = 'QUT1';
                msj = "COTIZACIONES";
                num = 23
                folioID = 'QT';
                break;
            case 'OR':
                table = 'ORDR';
                subTable = 'RDR1';
                msj = "ORDEN DE VENTA";
                num = 17;
                folioID = 'OR';
                break;
            case 'DL':
                table = 'ODLN';
                subTable = 'DLN1';
                msj = "ENTREGA";
                num = 15
                folioID = 'DL';
                break;
            case 'DH':
                table = 'ODLN';
                subTable = 'DLN1';
                msj = "ENTREGA A DOMICILIO";
                num = 15;
                folioID = 'DH';
                break;
            case 'RT':
                table = 'ORDN';
                subTable = 'RDN1';
                msj = "DEVOLUCIONES";
                num = 16
                folioID = 'RT';
                break;
            case 'CN':
                table = 'ORIN';
                subTable = 'RIN1';
                msj = "NOTA DE CRÉDITO";
                num = 14
                folioID = 'CN';
                break;
            case 'PY':
                table = '';
                subTable = '';
                msj = "COBRANZA";
                num = 0
                folioID = 'PY';
                break;

            case 'PI':
                table = '';
                subTable = '';
                msj = "ENTRADA DE EFECTIVO";
                num = 0;
                folioID = 'PI';
                break;
            case 'PO':
                table = '';
                subTable = '';
                msj = "SALIDA DE EFECTIVO";
                num = 0;
                folioID = 'PO';
                break;
            case 'AC':
                table = '';
                subTable = '';
                msj = "DEPÓSITO BANCARIO";
                num = 0;
                folioID = 'AC';
                break;

            case 'NM':
                table = 'ODLN';
                subTable = 'DLN1';
                msj = "NOTA DE MOSTRADOR";
                num = 112;
                folioID = 'NM';
                break;
            case 'IP':
                table = 'ORCT';
                subTable = ' ';
                msj = "Cobranza";
                num = 24;
                folioID = 'IP';
                break;
            case 'DP':
                table = 'ODPI';
                subTable = 'DPI1';
                msj = "FACTURA DE ANTICIPO";
                num = 203;
                folioID = 'DP';
                break;
            case 'MI':
                table = 'MI';
                subTable = '';
                msj = "ENTRADA DE DINERO"; // PETER
                num = -1;
                folioID = 'MI';
                break;
            case 'MO':
                table = 'MO';
                subTable = '';
                msj = "SALIDA DE DINERO"; // PETER
                num = -2;
                folioID = 'MO';
                break;
            default:
                msj = "NO SE ENCONTRÓ EL TIPO DE DOC";
                folioID = 'NO';
        }
        return { msj, table, subTable, DocEntry, num, folioID, codeBO, isElectronic };
    }

    async formatNumber(val) {
        // remove sign if negative
        var sign = 1;
        if (val < 0) {
            sign = -1;
            val = -val;
        }

        // trim the number decimal point if it exists
        let num = val.toString().includes('.') ? val.toString().split('.')[0] : val.toString();

        while (/(\d+)(\d{3})/.test(num.toString())) {
            // insert comma to 4th last position to the match number
            num = num.toString().replace(/(\d+)(\d{3})/, '$1' + ',' + '$2');
        }

        // add number after decimal point
        if (val.toString().includes('.')) {
            num = num + '.' + val.toString().split('.')[1];
        }

        // return result with - sign if negative
        return sign < 0 ? '-' + num : num;
    }

    async keepInterOpLines(data) {
        const { objType } = data
        let keepLines = false;
        switch (objType) {
            case '17':
            case '23':
                keepLines = true;
                break;

            default:
                keepLines = false;
                break;
        }
        return keepLines;
    }

}
export default generalFunctions;